import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { catchError, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { DevFlag, type DevFlagsMap } from '@core/dev-flags-types';
import { HttpApiService } from '@core/http-legacy';

@Injectable({ providedIn: 'root' })
export class DevFlagsHttpService {
  private readonly httpApi = inject(HttpApiService);

  public fetch(): Observable<DevFlagsMap> {
    return this.httpApi.get('/features').pipe(
      map(({ features }) =>
        Object.values(DevFlag).reduce(
          (acc, value) => {
            acc[value] = (features || []).includes(value);
            return acc;
          },
          <DevFlagsMap>{},
        ),
      ),
      catchError(error => {
        console.error(error);
        const fallbackMap = Object.values(DevFlag).reduce(
          (acc, value) => {
            acc[value] = false;
            return acc;
          },
          <DevFlagsMap>{},
        );
        return of(fallbackMap);
      }),
    );
  }
}
